import React, { FC } from 'react';
import './visitorDisplay.scss';
import type { Visitor } from 'core/visitRequestReview/types';
import { ChevronDownIcon, ChevronUpIcon, DeleteIcon, ValidNsipIcon } from 'components/Elements/CustomSVGIcon';
import { Collapse } from 'antd';

interface VisitorDisplayProps {
    visitor: Visitor;
    onDelete: () => void;
}

const VisitorDisplay: FC<VisitorDisplayProps> = ({ visitor, onDelete }) => {

    const renderIcon = (isActive: boolean | undefined) => {
        if (isActive) {
            return <ChevronUpIcon />;
        }
        return <ChevronDownIcon />;
    };

    const data = [
        {
            label: visitor.name,
            key: visitor.name,
            children: (
                <div key={visitor.id}>
                    <div className="visitor-details">
                        <div className="detail-wrapper">
                            <h5 className="label">Phone Number:</h5>
                            <span className="detail">{visitor.phoneNumber || 'Not provided'}</span>
                        </div>
                        <div className="detail-wrapper">
                            <h5 className="label">Email Address:</h5>
                            {/* NSIP visitor emails are redacted for data protection.
                                Prefer the masked value (set on search or reload),
                                falling back to whatever email is present. */}
                            <span className="detail">
                                {(visitor.nsipReference ? (visitor.maskedEmail || visitor.email) : visitor.email) || 'Not provided'}
                            </span>
                        </div>
                        <div className="detail-wrapper">
                            <h5 className="label">Company Name:</h5>
                            <span className="detail">{visitor.companyName}</span>
                        </div>
                        {visitor.nsipReference && (
                            <div className="detail-wrapper">
                                <h5 className="label">NSIP Reference:</h5>
                                <span className="detail">{visitor.nsipReference}</span>
                                {visitor.isValidNsip && (
                                    <span className="valid-nsip-text"><ValidNsipIcon /> Valid NSIP</span>
                                )}
                                {visitor.isExpired && (
                                    <span className="expired-nsip-text">(Expired)</span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            ) },
    ];

    return (
        <div className="visitor-content">
            <Collapse
                expandIconPosition="end"
                expandIcon={({ isActive }) => renderIcon(isActive)}
                items={data} />
            <div className="delete-wrapper" onClick={onDelete}>
                <DeleteIcon />
            </div>
        </div>
    );
};

export default VisitorDisplay;
